
// define the names of all the columns (properties) in a profile's 'extraInfo'
const ColumnNames = {
    memberLastName: 'PARTICIPANT LAST NAME',
    memberFirstName: 'PARTICIPANT FIRST NAME',
    memberDOB: 'BIRTH DATE',
    memberGender: 'SEX',
    spouseFirstName: 'SPOUSE FIRST NAME',
    spouseLastName: 'SPOUSE LAST',
    spouseDOB: 'SPOUSE BIRTH',
    spouseGender: 'SPOUSE SEX',
    futureService: 'FUTURE SERVICE',
    monthlyBenefit: 'MONTHLY BENEFIT',
    X401KAcctBal: '401k Acct Bal',
    fundOfficeEmployee: 'FUND OFFICE EMPLOYEE',
    monthlyBenefit20180531: 'MONTHLY BENEFIT THROUGH 5/31/2018'
}

const fundOfficeEmployee = {
    no: 12.95,
    yes: 3.63
}

export {
    ColumnNames,
    fundOfficeEmployee
}



// WEBPACK FOOTER //
// ./src/config/701/ETL/interfaces.ts